<template>
  <div>    
  </div>
</template>

<script>
export default {

  name: 'logout',
  beforeCreate() {
    this.$store.dispatch('logout');
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>